import { Link } from 'react-router'
import { Wordmark } from '../components/Wordmark'
import { useI18n } from '../i18n'
import styles from './NotFound.module.css'

export function NotFoundPage() {
  const { t } = useI18n()
  return (
    <main id="main" className={styles.wrap}>
      <Wordmark />
      <p className={styles.code} aria-hidden="true">
        404
      </p>
      <h1>{t('notfound.title')}</h1>
      <p>{t('notfound.body')}</p>
      <Link className="btn btn-primary" to="/">
        {t('notfound.back')}
      </Link>
    </main>
  )
}
